import { $api } from "../../../../services/request.config";

// Проверка пароля ЛК + отправка IC-заявки на согласование.
// Аналог passwordValidationAction, но для эндпоинтов individual-coefficients.
// /submit считаем успешным при любом 2xx: бэк отдаёт скудный DTO
// ({ uid, requestTypeId, isSuccess, details }), тело в стор не кладём.
export const verifyPasswordAndSubmitIndividualCoefficientThunkAction = ({
    password,
    uid,
    version,
    requestTypeName,
    setCorrectPassword,
    setSentStatus,
    setRequestTheme,
    setOnValidation,
    setModalError,
}) => async () => {
    try {
        const verify = await $api.post("v1/auth/verify/password", { password: password.password });
        if (verify.status !== 204) return;

        setCorrectPassword(true);
        setOnValidation(true);

        try {
            await $api.post(`v1/managers/requests/individual-coefficients/${uid}/submit`, { version });
            setRequestTheme && setRequestTheme(requestTypeName || null);
            setSentStatus(true);
        } catch (submitError) {
            // валидация уже прошла прямо перед этим шагом — сюда попадаем на редких
            // серверных/интеграционных ошибках отправки
            setModalError((prev) => ({ ...prev, sign: true, status: true }));
        } finally {
            setOnValidation(false);
        }
    } catch (error) {
        setOnValidation(false);
        const status = error.response?.status;
        if (status === 500) {
            setSentStatus(false);
            setModalError((prev) => ({ ...prev, sign: true, status: true }));
            return;
        }
        if (error.response?.data?.type === "verify-password-bad-request") {
            setCorrectPassword(false);
        } else if (status !== 204 && status !== 400) {
            setCorrectPassword(false);
        }
    }
};
